import Typography from '@mui/material/Typography';
import { Fragment } from 'react';
import { type AudienceAppliedFilterValue, MAX_VISIBLE_APPLIED_FILTER_VALUES } from './getAudienceAppliedFiltersDisplay';

type AppliedFilterValueListProps = {
  values: AudienceAppliedFilterValue[];
};

export const AppliedFilterValueList = ({ values }: AppliedFilterValueListProps) => {
  if (values.length === 0) {
    return null;
  }

  const visibleValues = values.slice(0, MAX_VISIBLE_APPLIED_FILTER_VALUES);
  const hiddenValues = values.slice(MAX_VISIBLE_APPLIED_FILTER_VALUES);
  const hiddenCount = hiddenValues.length;

  return (
    <>
      {visibleValues.map((value, index) => (
        <Fragment key={`${value.display}-${index}`}>
          {index > 0 && ', '}
          {value.display}
        </Fragment>
      ))}
      {hiddenCount > 0 && (
        <>
          {visibleValues.length > 0 && ' '}

          <Typography
            component="span"
            variant="inherit"
            data-test="audience-details-applied-filter-overflow-count"
            sx={{ cursor: 'default' }}
          >
            +{hiddenCount}
          </Typography>
        </>
      )}
    </>
  );
};
